'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../aviary-core/dist/cjs/index.cjs');

/**
 * SVG Illustration of auto refill package
 */ const AutoRefillPackage = ({ assetColor = index.ASSET_COLORS.grey, size = index.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M104 52C104 80.7188 80.7188 104 52 104C23.2812 104 0 80.7188 0 52C0 23.2812 23.2812 0 52 0C80.7188 0 104 23.2812 104 52Z",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M34.034 33.3792L17.8643 33.0379L18.949 34.1802L28.7278 44.3359L44.661 44.3359L34.034 33.3792Z",
                fill: theme.ds5.asset[assetColor]["400"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M45.4335 36.2568V32.6863H46.4173C46.8961 32.6863 47.2842 32.2982 47.2842 31.8194V29.6872C47.2842 29.2084 46.8961 28.8203 46.4173 28.8203H31.191C30.7122 28.8203 30.3241 29.2084 30.3241 29.6872V31.8194C30.3241 32.2982 30.7122 32.6863 31.191 32.6863H32.1748V36.2947C31.1593 36.6656 30.2835 37.3327 29.6651 38.2066C29.0466 39.0805 28.7151 40.1193 28.7148 41.1836V58.858C28.7148 59.3368 29.1029 59.7249 29.5817 59.7249H48.1384C48.6172 59.7249 49.0053 59.3368 49.0053 58.858V41.1859C49.0052 40.1016 48.6612 39.0441 48.0211 38.1607C47.381 37.2773 46.4765 36.6118 45.4335 36.2568Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M58.3855 41.4549V38.2365H59.1158C59.5945 38.2365 59.9826 37.8484 59.9826 37.3696V35.904C59.9826 35.4252 59.5945 35.0371 59.1158 35.0371H46.2127C45.734 35.0371 45.3458 35.4252 45.3458 35.904V37.3696C45.3458 37.8484 45.734 38.2365 46.2127 38.2365H46.943V41.4876C46.0666 41.8077 45.3108 42.3835 44.7771 43.1376C44.2434 43.8918 43.9572 44.7883 43.957 45.7068V60.8413C43.957 61.3201 44.3451 61.7082 44.8239 61.7082H60.6011C61.0799 61.7082 61.468 61.3201 61.468 60.8413V45.7088C61.4679 44.773 61.171 43.8604 60.6186 43.098C60.0662 42.3356 59.2856 41.7613 58.3855 41.4549Z",
                fill: theme.ds5.asset[assetColor]["400"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "30.1719",
                y: "28.8301",
                width: "17.2368",
                height: "4.77994",
                rx: "0.596867",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "45.0859",
                y: "35",
                width: "15.0641",
                height: "4.05571",
                rx: "0.596867",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M61.3164 44.332H77.2496V78.371H61.3164V44.332Z",
                fill: theme.ds5.asset[assetColor]["400"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M71.9465 33.3714L88.1161 33.0301L87.0315 34.1724L77.2526 44.3281L61.3195 44.3281L71.9465 33.3714Z",
                fill: theme.ds5.asset[assetColor]["400"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M28.7227 44.332H61.3132V78.371H28.7227V44.332Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M53.0273 55.2863L52.7846 56.6757C52.5953 56.2512 52.3378 55.8802 51.908 55.5916C51.3387 55.2039 50.6515 55 49.8577 55C48.964 55 48.1191 55.2384 47.3446 55.6941C46.57 56.151 45.8987 56.7938 45.3668 57.6061C45.1422 57.9448 44.9347 58.3158 44.7794 58.7058L45.6582 59.2629C46.0359 59.4835 46.2604 59.9058 46.2604 60.3448C46.2434 60.8528 45.9338 61.3264 45.4689 61.5793L44.1602 62.2567C44.1772 62.6121 44.2305 62.9509 44.3325 63.2729C44.59 64.0684 45.022 64.6767 45.6412 65.1157C46.2604 65.5547 47.035 65.7586 47.932 65.7586C48.7236 65.7586 49.48 65.5726 50.1854 65.216C50.7195 64.9464 51.1176 64.5586 51.4442 64.1341L51.1845 65.606H54.8509L56.7119 55.2875H53.0273V55.2863ZM52.0985 60.4294C51.9591 61.2562 51.6495 61.8991 51.2197 62.3559C50.7728 62.7971 50.2205 63.0155 49.5662 63.0155C48.9118 63.0155 48.4117 62.7971 48.1373 62.3559C47.8628 61.9169 47.7925 61.2907 47.9479 60.464C48.1033 59.6172 48.3981 58.9576 48.862 58.4841C49.3088 58.0105 49.8588 57.7899 50.5131 57.7899C51.1675 57.7899 51.6495 58.0105 51.9273 58.4495C52.2017 58.9064 52.2698 59.566 52.0997 60.4294H52.0985Z",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M45.0122 60.7943L44.1211 61.2692L39.0403 63.8995C38.9533 63.9486 38.8685 63.9654 38.7814 63.9654C38.5247 63.9654 38.3177 63.7609 38.3709 63.4737L38.6977 61.677C38.7497 61.4044 38.5609 61.2021 38.3019 61.2021H34.37C34.1134 61.2021 33.9596 60.9976 34.0093 60.7596L34.1461 59.9797C34.1812 59.7607 34.4051 59.5562 34.6618 59.5562H38.5948C38.8515 59.5562 39.1082 59.335 39.1602 59.0813L39.487 57.2824C39.539 56.9941 39.7957 56.793 40.0547 56.793C40.1395 56.793 40.2243 56.8254 40.2933 56.8589L44.4298 59.4892L45.1671 59.9641C45.4781 60.1317 45.391 60.6066 45.0133 60.7932L45.0122 60.7943Z",
                fill: theme.ds5.asset[assetColor]["500"]
            })
        ]
    });
};

exports.AutoRefillPackage = AutoRefillPackage;
//# sourceMappingURL=AutoRefillPackage.cjs.map
